import { render, staticRenderFns } from "./LoginFormAzB2cUserFlow.vue?vue&type=template&id=71e2973a&lang=html&"
import script from "./LoginFormAzB2cUserFlow.vue?vue&type=script&lang=js&"
export * from "./LoginFormAzB2cUserFlow.vue?vue&type=script&lang=js&"
import style0 from "./LoginFormAzB2cUserFlow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports